import {isC3Experience} from "../../../../experience-client/src/shared/util/C3Utils";
define((require) => {
    "use strict";

    const {template, pluck}          = require("underscore");
    const ChannelConfig              = require("ui/publish/channelSetup/ChannelConfig");
    const GroupUtil                  = require("ui/groups/GroupUtil");
    const NotificationBar            = require("editor/ui/notificationbar/NotificationBar");
    const Promise                    = require("shared/util/Promise");
    const PublishableState           = require("util/PublishableState");

    const DELETE_PUSHED_ENTITY_TEMPLATE = template("Are you sure you want to delete the <%=typeUnescaped%> <%=itemNameUnescaped%>?");
    const templates = {
        [PublishableState.PUBLISHED.value]: template("<%=itemNameUnescaped%> is currently published in: <%= slotsTextUnescaped %> - are you sure you want to delete it?"),
        [PublishableState.SCHEDULED.value]: template("<%=itemNameUnescaped%> is scheduled for publishing in: <%= slotsTextUnescaped %> - are you sure you want to delete it?"),
        [PublishableState.PUSHED.value]: DELETE_PUSHED_ENTITY_TEMPLATE,
        [PublishableState.NOT_PUSHED.value]: DELETE_PUSHED_ENTITY_TEMPLATE
    };

    const warnings = {

        /**
         * Returns a warning message based on state and its variants when deleting an experience.
         * The text is unescaped, because this is currently used in a confirm box.
         * @param {ExperienceModel|GroupModel} model Either an Experience model or Group Model (Experience with variants)
         * @param {String} type Display string type of the model ("Experience" / "Variant" / etc)
         * @returns {Promise}    Promise returning the compiled warning message
         */
        fetchDeleteExperienceMessage(model, type) {

            if (isC3Experience()) {
                return Promise.resolved("Are you sure you want to delete this Variant ?");
            }

            const state = GroupUtil.getState(model).value;
            const itemName = `"${model.get("name")}"`;

            switch (state) {
                case PublishableState.PUBLISHED.value:
                    // fallthrough
                case PublishableState.SCHEDULED.value:
                    return ChannelConfig.fetchByType(model.get("type"), model.id)
                        .then((response) => templates[state]({
                            itemNameUnescaped: itemName,
                            slotsTextUnescaped: pluck(response, "name").join(", ")
                        })).fail(() => {
                        // API failure
                            NotificationBar.error(`Internal error collecting usage data for this ${model.get("type")}`);
                        });

                default: {
                    const messageText = templates[state]({
                        itemNameUnescaped: itemName,
                        typeUnescaped: type
                    });
                    return Promise.resolved(messageText);
                }
            }
        }

    };

    return warnings;
});



// WEBPACK FOOTER //
// ./src/editor/util/WarningMessages.js